import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  whenPill: {
    description: 'Pill label shown on the trigger step card indicating the trigger condition',
    defaultMessage: 'When',
    id: '1ncD+8',
  },
  ifAndThenPill: {
    description: 'Pill label shown on rule step cards indicating conditions and actions',
    defaultMessage: 'If & Then',
    id: 'Efm2GJ',
  },
  defaultStepTitle: {
    description: 'Fallback title shown on a rule step card when no title has been set',
    defaultMessage: 'Action',
    id: '0WlM2C',
  },
  deleteStep: {
    description: 'Label for the delete action in the step card context menu',
    defaultMessage: 'Delete',
    id: 'QkBTYC',
  },
  stepOptionsAriaLabel: {
    description: 'Aria label for the step options menu button on a workflow step card',
    defaultMessage: 'Step options',
    id: 'y0UV6t',
  },
});
